import React from "react";
import AppComponent from "../../../Components/AppComponent";
import _ from "lodash";

import UnpActions from "../../../Stores/redux/UnPersist/Actions";
import PActions from "../../../Stores/redux/Persist/Actions";
import { connect } from "react-redux";
import AppModal from "../../../Components/Models/app-modal";
import { Form, Button, InputGroup, FormControl } from "react-bootstrap";
import api from "../../../Services/Api/api";

const SCREEN_NAME = "EDIT_AGENT_SCREEN";

class EditAgentInner extends AppComponent {
  state = {
    firstName: this.props.agent?.firstName || "",
    lastName: this.props.agent?.lastName || "",
    countryCode: this.props.agent?.countryCode || "91",
    phone: this.props.agent?.phone || "",
    email: this.props.agent?.email || "",
    address: this.props.agent?.address || "",
  };

  formRef = React.createRef(null);

  async onSubmit() {
    try {
      if (this.state.loading) return;
      const isValid = this.formRef?.current?.reportValidity();
      if (!isValid) return;

      this.setAsyncState({ loading: true, error: null });
      const payload = _.pick(this.state, [
        "firstName",
        "lastName",
        "countryCode",
        "phone",
        "email",
        "address",
      ]);

      let res = null;
      if (this.props.agent?._id) {
        res = await api.patch(
          `v1/agent/${this.props.agent._id}`,
          payload
        );
      } else {
        res = await api.post("v1/agent", payload);
      }

      this.setAsyncState({ loading: false });
      this.props.onSubmit(res);
    } catch (e) {
      this.setAsyncState({ error: e.message, loading: false });
    }
  }

  renderForm() {
    const {
      props: { renderModal = false },
      state: {
        firstName,
        lastName,
        phone,
        countryCode,
        email,
        address,
        error,
      },
    } = this;

    return (
      <Form
        onSubmit={(e) => {
          e.preventDefault();
          this.onSubmit();
        }}
        ref={this.formRef}
      >
        <Form.Group className="mb-3">
          <Form.Label>First Name</Form.Label>
          <Form.Control
            type="text"
            placeholder="First Name"
            value={firstName}
            onChange={(e) => this.setAsyncState({ firstName: e.target.value })}
            required
          />
        </Form.Group>

        <Form.Group className="mb-3">
          <Form.Label>Last Name</Form.Label>
          <Form.Control
            type="text"
            placeholder="Last Name"
            value={lastName}
            onChange={(e) => this.setAsyncState({ lastName: e.target.value })}
            required
          />
        </Form.Group>

        <Form.Group className="mb-3">
          <Form.Label>Phone Number</Form.Label>
          <InputGroup className="mb-3">
            <FormControl
              type="number"
              aria-label="Country Code"
              style={{ maxWidth: "8rem" }}
              placeholder="Country Code"
              value={countryCode}
              onChange={(e) =>
                this.setAsyncState({ countryCode: e.target.value.trim() })
              }
            />
            <FormControl
              type="number"
              aria-label="Phone Number"
              placeholder="Phone Number"
              value={phone}
              onChange={(e) =>
                this.setAsyncState({ phone: e.target.value.trim() })
              }
            />
          </InputGroup>
        </Form.Group>

        <Form.Group className="mb-3">
          <Form.Label>Email</Form.Label>
          <Form.Control
            type="email"
            placeholder="Email"
            value={email}
            onChange={(e) => this.setAsyncState({ email: e.target.value })}
          />
        </Form.Group>

        <Form.Group className="mb-3">
          <Form.Label>Address</Form.Label>
          <Form.Control
            as="textarea"
            rows={3}
            placeholder="Address"
            value={address}
            onChange={(e) => this.setAsyncState({ address: e.target.value })}
          />
        </Form.Group>

     

        <div className="errormsg">{error}</div>

        {renderModal ? null : (
          <Button variant="primary" type="submit">
            Submit
          </Button>
        )}
      </Form>
    );
  }

  renderModal() {
    return (
      <AppModal
        {...{
          visible: this.props.visible,
          handleClose: this.props.handleClose,
          title: this.props.agent?._id
            ? "Edit Agent"
            : "Add New Agent",
          onSubmit: this.onSubmit.bind(this),
          disableSubmit: this.state.loading,
        }}
      >
        {this.renderForm()}
      </AppModal>
    );
  }

  render() {
    const {
      props: { renderModal = false },
    } = this;

    if (renderModal) return this.renderModal();
    else return this.renderForm();
  }
}

const mapStateToProps = (state) => ({});

const mapDispatchToProps = (dispatch) => ({
  setScreenState: (obj, persist = false, screenName = SCREEN_NAME) =>
    persist
      ? dispatch(PActions.setPScreenState(screenName, obj))
      : dispatch(UnpActions.setVScreenState(screenName, obj)),
});

const EditAgent = connect(
  mapStateToProps,
  mapDispatchToProps
)(EditAgentInner);

export default EditAgent;
